export default __webpack_public_path__ + "static/media/main-banner.c621c74c.jpg";